import { createFileRoute, redirect } from '@tanstack/react-router';
import { getCurrentAuthorizeQuery } from '@/lib/oauth/oauth-flow';
import { OAuthSelectCompanyPage } from '@/pages/oauth/OAuthSelectCompanyPage';

export const Route = createFileRoute('/_oauth/oauth/select-company')({
	beforeLoad: () => {
		const read = getCurrentAuthorizeQuery();
		if (read.kind === 'valid') return;
		throw redirect({
			to: '/oauth/error',
			search: { error: read.kind === 'expired' ? 'request_expired' : 'invalid_request' },
		});
	},
	component: OAuthSelectCompanyPage,
});
